import React from 'react'
import Sidebar from '../Components/Sidebar'
import { Outlet } from 'react-router-dom'

const SABLayout = () => {

  return (
    <div className='flex'>
        <Sidebar />
      <div className={'w-full'}>
        <Outlet />
      </div>
    </div>
  )
}

export default SABLayout
